import { supabase } from './supabase';

export type EmailAttachment = {
  filename: string;
  content: string;
  contentType?: string;
};

export type EmailPayload = {
  to: string;
  subject: string;
  text: string;
  html?: string;
  replyTo?: string;
  attachments?: EmailAttachment[];
};

export type LeadEmailPayload = {
  locale?: string;
  name: string;
  email: string;
  phone?: string;
  company?: string;
  product?: string;
  message: string;
  budget?: string;
  source?: string;
  landingUrl?: string;
};

export type EmailResult = {
  sent: boolean;
  fallback: boolean;
};

const EMAIL_ENDPOINT = '/api/send-email';

async function postEmail(body: unknown, accessToken?: string | null): Promise<EmailResult> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }
  const response = await fetch(EMAIL_ENDPOINT, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    return { sent: false, fallback: false };
  }
  return { sent: true, fallback: false };
}

export async function sendTransactionalEmail(payload: EmailPayload): Promise<EmailResult> {
  try {
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    if (!token) {
      return { sent: false, fallback: false };
    }
    return await postEmail({ kind: 'transactional', ...payload }, token);
  } catch {
    return { sent: false, fallback: false };
  }
}

export async function notifyLeadByEmail(lead: LeadEmailPayload): Promise<EmailResult> {
  try {
    return await postEmail({
      kind: 'lead',
      locale: lead.locale,
      lead,
    });
  } catch {
    return { sent: false, fallback: false };
  }
}
